import script from "./dclist.vue?vue&type=script&setup=true&lang=js"
export * from "./dclist.vue?vue&type=script&setup=true&lang=js"

import "./dclist.vue?vue&type=style&index=0&id=1a7d0a80&lang=scss"

const __exports__ = script;

export default __exports__